var module = angular.module('appsflyer', []);

module.provider('appsflyer', function appsflyerProvider() {

    this.$get = function appsflyer(LocalStorage) {

        var devKey = this.devKey,
            appId = this.appId,
            options = this.options,
            sdk;

        return {
            init: function () {

                if (ionic.Platform.isIOS()) {
                    options.appId = appId;
                }

                options.devKey = devKey;

                function onSuccess(data) {
                    var ls = LocalStorage.get('appsflyer');

                    log('AppsFlyer SDK init successful');

                    if (ls && ls === 'done') return;

                    LocalStorage.set('appsflyer', typeof data === 'object' ? JSON.stringify(data || {}) : data);

                    return data;
                }

                function onError() {
                    log('Failed to init AppsFlyer SDK');
                    return;
                }

                try {
                    sdk = window.plugins.appsFlyer;
                    sdk.initSdk(options, onSuccess, onError);
                } catch (e) {
                    log('AppsFlyer plugin is not found in window.plugins');
                }
            },

            setAppUserId: function (userId) {
                try {
                    sdk.setAppUserId(userId);
                }
                catch (e) {
                    log('AppsFlyer plugin is not found in window.plugins');
                }
            },

            trackEvent: function (event, data) {
                try {
                    sdk.trackEvent(event, data);
                }
                catch (e) {
                    log('AppsFlyer plugin is not found in window.plugins');
                }
            }
        }

    }

});